import { BCMSRecord, DisabledPrompt, Link, useBCMSContext, useStateManager, useWorkflow } from "@bcm-dev/bcms-vite";
import { PageContainer } from 'components/shared';
import Classes from "model";
import React from 'react';
import { SVGAsset } from 'res';
import "./styles.css";

/**
 * @function CheckImageGuidelinesManualPage
 * @return {React.Component}
 * @exported true
 * @description A page in the "deposit a check" workflow.
 */
export default function CheckImageGuidelinesManualPage(props) {
  const { goStep, nextStep } = useWorkflow() ?? {};
  const context = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, context);

  const data = { ...getDefaultPageData(), ...props.data ?? {} };
  const ui = { ...getDefaultPageUI(), ...props.ui ?? {} };

  const state = { data, ui };
  const mobileDepositsVersion = data.mobileDepositsVersion ?? "";
  const selectedCheckView = ui.selectedCheckView ?? "";

  const controller = (state, setState) => ({
      data: state.data,
      ui: state.ui,

      onCancelClick: evt => goStep(0),

      onContinueClick: evt => {
        if(mobileDepositsVersion.version === "manual front & back images" || mobileDepositsVersion.version === "manual check images") {
          goStep(selectedCheckView === "front" ? 9 : 11);
        }
      }
  });

  return(
    <PageContainer className="check-image-guidelines-manual-page" state={ state } controller={ controller }>
      <PageContent/>
    </PageContainer>
  );
}

export const getDefaultPageData = () => ({
  
});
export const getDefaultPageUI = () => ({
  
});

function PageContent() {
  const { onCancelClick, onContinueClick } = useStateManager();
  
  return (
    <div className="check-image-page-content flex-container flex-vertical">
        <div className="set-height"></div>
    <div className="upper-container flex-container flex-vertical justify-center flex-height">
        <div className="flex-container flex-horizontal align-center guideline-container">
          <SVGAsset id="RightArrowIcon" className="arrow-icon set-width inline-text-icon left-icon" />
          <p>Center the document on a dark surface, provide ample light. Align document.</p>
        </div>
        <div className="flex-container flex-horizontal align-center guideline-container">
          <SVGAsset id="RightArrowIcon" className="arrow-icon set-width inline-text-icon left-icon" />
          <p>Tap the capture button when ready.</p>
        </div>
        <DisabledPrompt>
            <div className="flex-height"></div>
            <div className="set-height">
                <div className="dont-show-screen-again-container text-center">
                    <input type="checkbox" id="dont_show_screen_again"/>
                    <label htmlFor="dont_show_screen_again">Don't show this screen again</label>
                </div>
            </div>
        </DisabledPrompt>
      </div>
      
      <div className="check-image-footer flex-container flex-horizontal align-center set-width">
        <Link className="flex-width cancel-link clickable text-center" onClick={ onCancelClick }>Cancel</Link>
        <Link className="flex-width continue-link clickable text-center" onClick={ onContinueClick }>Capture Manually</Link>
      </div>
    </div>
  );
}